var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDownMyFeedback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.896447 0.896447C1.09171 0.701185 1.40829 0.701185 1.60355 0.896447L4.88215 4.17504C4.94723 4.24013 5.05276 4.24013 5.11785 4.17504L8.39644 0.896447C8.59171 0.701185 8.90829 0.701185 9.10355 0.896447C9.29881 1.09171 9.29881 1.40829 9.10355 1.60355L5.82496 4.88215C5.36935 5.33776 4.63065 5.33776 4.17504 4.88215L0.896447 1.60355C0.701184 1.40829 0.701184 1.09171 0.896447 0.896447Z",
    fill: "#888F9D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownMyFeedback);
export default __webpack_public_path__ + "static/media/arrowDownMyFeedback.b4a1a5ea00e238e2c18cc377cb436cca.svg";
export { ForwardRef as ReactComponent };